import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Radio } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function GoogleCallback() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setUserData } = useAuth();

  useEffect(() => {
    const code = searchParams.get("code");
    if (!code) {
      setError("No authorization code received");
      return;
    }

    const redirect_uri = `${window.location.origin}/auth/google/callback`;

    fetch(`${BACKEND_URL}/api/auth/google/callback`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code, redirect_uri }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Authentication failed");
        return res.json();
      })
      .then((data) => {
        localStorage.setItem("token", data.token);
        setUserData(data.user, data.token);
        navigate("/dashboard");
      })
      .catch((err) => {
        setError(err.message || "Authentication failed");
      });
  }, [searchParams, navigate, setUserData]);

  return (
    <div className="min-h-screen bg-[#0a0a14] flex items-center justify-center">
      <div className="text-center">
        <Radio className="w-10 h-10 text-purple-400 mx-auto mb-4 animate-pulse" />
        {error ? (
          <>
            <p className="text-red-400 mb-4">{error}</p>
            <button onClick={() => navigate("/")} className="text-purple-400 hover:text-purple-300 text-sm">
              Back to Home
            </button>
          </>
        ) : (
          <p className="text-white/60 text-sm">Signing you in...</p>
        )}
      </div>
    </div>
  );
}
